<template>
  <div class="tabs">
    <div class="tabs__list-wrapper">
      <div :class="['tabs__list', { 'tabs-inner__list': tabsInner }]">
        <div
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab', { 'active': tab.id === activeTab }]"
            @click="setActiveTab(tab.id)"
        >
          <div class="tab__label">
            <p>{{ $t(tab.label) }}</p>
          </div>
        </div>
      </div>
    </div>
    <slot name="tabs-content"></slot>
  </div>
</template>

<script>
  export default {
    props: {
      activeTab: {
        type: Number,
        default: 1,
      },

      tabs: {
        type: Array,
        default: () => [],
      },

      tabsInner: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      setActiveTab(tabId) {
        this.$emit('activeTab', tabId);
      },
    },
  }
</script>
